import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import logo from "../../../../src/assets/images/ASK_-_JEEVES-01-removebg-preview (1).png";


const PublicChatView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const token = params.get("token");
    const sessionId = params.get("sessionId");


    if (token) {
      getChats(token);
    }
  }, [location.search]);
  const [Data, setSetData] = useState(null);
  const getChats = (token) => {
    fetch(`${process.env.REACT_APP_API_PATH}/shared-chat/${token}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setSetData(data);
        if(data.message === "Invalid or expired token") {
        navigate("/not-found");
          return;
        }
      })
      .catch((error) => {
        console.error("Error fetching public chat data:", error);
      });
  };

  return (
    <>
      <div className="min-h-screen  text-white flex justify-center relative">
        <div className="flex justify-start absolute -top-10 left-0 p-4 ">
          <img src={logo} alt="Logo" className="w-28 h-28 mt-10" />
        </div>
        <div className="w-full max-w-3xl px-6 py-10">
         

          {/* 🔹 Meta Info */}
          <p className="text-center text-gray-400 text-sm mb-10">
            Shared conversation •
            {new Date(Data?.messages[0]?.timestamp).toLocaleString()}
          </p>
           <h1 className="self-end bg-gray-200 px-4 py-2 rounded-2xl max-w-xs break-words mb-4 text-black">
            {Data?.messages[0]?.question}
          </h1>

          {/* 🔹 Chat Thread */}
          <div className="space-y-10">
            {Data?.messages.map((msg, index) => (
              <div key={msg._id} className="space-y-4">
                {index !== 0 && (
                  <div className="flex items-end bg-gray-200 px-4 py-2 text-black rounded-2xl max-w-xs break-words mb-4">
                    {msg.question}
                  </div>
                )}

                {/* ✅ Answer */}
                <div className="bg-white-400 p-5 rounded-2xl text-black leading-relaxed shadow-sm">
                  {msg.answer}
                </div>

                {/* 🕒 Timestamp */}
                <div className="text-xs text-gray-500">
                  {new Date(msg.timestamp).toLocaleTimeString()}
                </div>
              </div>
            ))}
          </div>
          {/* <div ref={bottomRef} /> */}
        </div>
      </div>
    </>
  );
};

export default PublicChatView;
